// Single source of truth for "is this user an admin?".
// Mirrors the gate used by AdminLogin/AuthContext: Cognito "Admins" group OR
// hardcoded email allowlist. Keep this list in sync with the one in
// web/src/components/pages/AdminLogin/AdminLogin.js (a future cleanup should
// dedupe by importing from here).

export const ADMIN_EMAILS = [
  "davidhudman@gmail.com",
  "admin@activebeaches.com",
  "test@activebeaches.com",
  "test@test.com",
  "david@activebeaches.com",
];

const ADMIN_EMAIL_SET = new Set(ADMIN_EMAILS.map((e) => e.toLowerCase()));

const decodeJwt = (token) => {
  if (!token || typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length < 2) return null;
  try {
    // base64url -> base64
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "===".slice((base64.length + 3) % 4);
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
};

export const isAdminFromPayload = (payload) => {
  if (!payload) return false;
  const email = (payload.email || "").toLowerCase();
  if (email && ADMIN_EMAIL_SET.has(email)) return true;
  const groups = payload["cognito:groups"];
  if (Array.isArray(groups) && groups.includes("Admins")) return true;
  if (typeof groups === "string" && groups.split(",").includes("Admins")) {
    return true;
  }
  return false;
};

export const isAdminFromToken = (token) =>
  isAdminFromPayload(decodeJwt(token));
